import { render } from "./VoucherListPage.vue?vue&type=template&id=2ef05612&scoped=true"
import script from "./VoucherListPage.vue?vue&type=script&lang=js"
export * from "./VoucherListPage.vue?vue&type=script&lang=js"

import "./VoucherListPage.vue?vue&type=style&index=0&id=2ef05612&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ef05612"

export default script